import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    FormErrorMessage,
} from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';

const ApprovalCodePlan = ({ errors, touched, darkMode, partnerPlans }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = 'ChakraSelect';

    return (
        <FormControl
            isInvalid={!!errors.planID && touched.planID}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Customer Default Plan
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the default plan for this approval code.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}>
                    <Field
                        name="planID"
                        validate={(value) =>
                            !value ? 'Plan is required' : undefined
                        }>
                        {({ form, meta }) => {
                            const selectedOption =
                                partnerPlans.find(
                                    (plan) => plan.value === form.values.planID,
                                ) || null;
                            return (
                                <>
                                    <ChakraSelect
                                        minWidth="410px"
                                        width="100%"
                                        data-walkthroughid={
                                            createMode.ufDefaultPlanSelect
                                        }
                                        options={partnerPlans}
                                        placeholder="- Select Plan -"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                        }}
                                        getOptionLabel={(i) => i.label}
                                        getOptionValue={(i) => i.value}
                                        chakraStyles={dropDownFormStyle(
                                            darkMode,
                                        )}
                                        isLoading={form.isSubmitting}
                                        isDisabled={form.isSubmitting}
                                        value={selectedOption}
                                        onChange={(option) => {
                                            form.setFieldValue(
                                                'planID',
                                                option ? option.value : '',
                                            );
                                            form.validateField('planID');
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(
                                                'planID',
                                                true,
                                            );
                                        }}
                                        isRequired
                                    />
                                    {meta.touched && meta.error && (
                                        <FormErrorMessage
                                            display="flex"
                                            sx={{
                                                marginTop: '0 !important',
                                                fontSize: '10px',
                                            }}
                                            justifyContent="flex-end">
                                            {meta.error}
                                        </FormErrorMessage>
                                    )}
                                </>
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the default plan for this approval code."
                        ariaLabel="approval-code-plan-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodePlan;
